import CloseIcon from '@mui/icons-material/Close'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Box, IconButton, styled } from '@mui/material'
import { MouseEventHandler } from 'react'

import EditButton from './TitleBarEditButton'

const Bar = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[400],
  padding: theme.spacing(1),
  color: 'white',
  fontWeight: 'bolder',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}))

interface MinimizationIconProps {
  minimized: boolean
  onClick: MouseEventHandler
}
const MinimizationButton = (props: MinimizationIconProps) => {
  const { minimized, onClick } = props

  return (
    <IconButton size="small" onClick={onClick}>
      {minimized ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
    </IconButton>
  )
}

function barTitle(processing: boolean, someFailed: boolean): string {
  if (processing) {
    return 'ファイルの登録中...'
  }
  return someFailed ? '登録失敗したファイルがあります ' : 'ファイルの登録完了'
}

interface Props {
  processing: boolean
  someFailed: boolean
  minimized: boolean
  showEdit: boolean
  onEditClick: MouseEventHandler
  onCloseClick: MouseEventHandler
  onMinClick: MouseEventHandler
}

const TitleBar = (props: Props) => {
  const { processing, someFailed, minimized, showEdit, onCloseClick, onEditClick, onMinClick } =
    props

  return (
    <Bar>
      {barTitle(processing, someFailed)}
      {showEdit && <EditButton onClick={onEditClick} />}
      <div>
        <MinimizationButton minimized={minimized} onClick={onMinClick} />
        <IconButton size="small" onClick={onCloseClick}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>
    </Bar>
  )
}

export default TitleBar
